import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import DOMPurify from 'dompurify'
import FormInput from '../../components/form-input'
import Button from '../../components/button'
import { useLogin } from '../../redux/user/hook'
import { formValidation } from '../../utils/functions'
import AuthLayout from '../../components/layouts/auth'
import { useSelector } from 'react-redux'
import GoogleImage from '../../assets/img/google-play-badge.png'
import AppleImage from '../../assets/svg/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'
import PasswordInput from '../../components/PasswordInput'

const SignInPage = () => {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })

  const { webToken } = useSelector((state) => state.userSlice)

  const { mutate: signIn, isLoading: loading } = useLogin()

  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  const submitForm = async (data) => {
    const email = DOMPurify.sanitize(data?.email)
    const password = DOMPurify.sanitize(data?.password)
    const web_token = webToken ? webToken : 'no_token'

    const requestData = {
      source: 'web',
      web_token,
      email,
      password,
    }
    signIn(requestData)
  }

  return (
    <AuthLayout>
      <React.Fragment>
        <form className='form' onSubmit={handleSubmit(submitForm)}>
          <div className='w-full text-center flex flex-col pb-[15px] items-center'>
            <span
              className={'header-3-regular md:header-2 text-secondary-2 pb-1'}
            >
              Welcome back.
            </span>
            <span className={'header-4 text-secondary-2 pb-1'}>
              Employee self service portal.
            </span>
          </div>
          <div className='flex flex-col gap-2 p-2 border bg-secondary-2-extralight rounded-md'>
            <div className='text-secondary-2 font-semibold flex justify-center w-full '>
              Login via mobile app
            </div>
            <div className='flex items-center gap-2 w-full px-3 mt-2'>
              <a
                href='https://play.google.com/store/apps/details?id=com.centelhr.app'
                target='_blank'
              >
                <img width='220' src={GoogleImage} alt='android' />
              </a>
              <a
                href='https://apps.apple.com/ng/app/centelhr/id6743995408'
                target='_blank'
              >
                <img width='220' src={AppleImage} alt='ios' />
              </a>
            </div>
          </div>

          <div className='flex justify-center items-center flex-row mt-[10px] font-bold text-[15px] mb-[10px]'>
            <div className='bg-color-border w-[100%] h-[1px] mr-[6px]'></div>
            <p className='!text-[18px]'>or</p>
            <div className='bg-color-border w-[100%] h-[1px] ml-[6px]'></div>
          </div>
          <FormInput
            label='Email'
            name='email'
            placeholder={'Enter your email'}
            type='text'
            inputRef={register(formValidation('text', true))}
            readOnly={loading}
            error={errors.email}
            errorMessage={errors.email && errors.email.message}
          />
          <PasswordInput
            label='Password'
            placeholder={'Enter your password'}
            name='password'
            inputRef={register(formValidation('password', true))}
            readOnly={loading}
            error={errors.password}
            errorMessage={errors.password && errors.password.message}
          />
          <div className='flex justify-between pb-[5px] pt-[5px]'>
            <FormInput
              label='Remember me'
              name='remember'
              type='checkbox'
              inputRef={register(formValidation('checkbox'))}
              readOnly={loading}
              error={errors.remember}
              errorMessage={errors.remember && errors.remember.message}
            />
            <p className='forgot_password cursor-pointer hover:underline text-[14px]'>
              <Link to='/forgot'>Forgot Password?</Link>
            </p>
          </div>
          <Button
            text='Sign in'
            type='submit'
            loading={loading}
            disabled={!isValid}
          />
        </form>
        <span className='flex justify-center items-center text-[14px] text-color-gray mt-4'>
          Don’t have an account?&ensp;
          <Link to='/register'>
            <span className='text-[14px] font-extrabold cursor-pointer hover:underline'>
              Sign Up
            </span>
          </Link>
        </span>
      </React.Fragment>
    </AuthLayout>
  )
}

export default SignInPage
